import Belly from "../img/belly.png";
import Butt from "../img/butt.png";
import Legs from "../img/legs.png";
import Chest from "../img/chest.png";

export const DATA = { Belly, Butt, Legs, Chest };
